import React, { useState } from 'react';
import './customTabs.css'; // se importa el CSS personalizado

const CustomTabs = ({ tabs, defaultActiveKey }) => {
  const [activeKey, setActiveKey] = useState(defaultActiveKey || (tabs[0] && tabs[0].key));

  return (
    <>
      <div className="custom-tabs-headers">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`custom-tab-button ${activeKey === tab.key ? 'active' : ''}`}
            onClick={() => setActiveKey(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="custom-tabs-content">
        {tabs.find(tab => tab.key === activeKey)?.content}
      </div>
    </>
  );
};

export default CustomTabs;
